import { render, staticRenderFns } from "./AlpineIcon.vue?vue&type=template&id=450cc52c&scoped=true"
import script from "./AlpineIcon.vue?vue&type=script&lang=ts"
export * from "./AlpineIcon.vue?vue&type=script&lang=ts"
import style0 from "./AlpineIcon.vue?vue&type=style&index=0&id=450cc52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450cc52c",
  null
  
)

export default component.exports